import React from 'react';
import styled, { ThemeContext } from 'styled-components';
import Plx from 'react-plx';
import {
  SectionName, buildPlxData,
} from '../common/styles';
import {
  BaseDesc, BaseTitle, BaseContainer, BaseImage,
} from './styles';

const vPadding = 90;
const Container = styled(BaseContainer)`
  margin-top: ${vPadding + 8}px;
  ${props => (!props.theme.isMobile && `
    margin-bottom: ${vPadding + 8}px;
  `)};
`;

const SImage = styled(BaseImage)`
  ${props => (!props.theme.isMobile && `
    max-width: 420px;
    max-height: 403px;
  `)};
`;

export default function FollowTrustedFunds() {
  const { follow, isMobile } = React.useContext(ThemeContext);
  const plxData = buildPlxData('#follow', vPadding);

  return (
    <Container id="follow">
      <Plx className="base-section" parallaxData={plxData.image} disabled={isMobile}>
        <SImage src={follow} />
      </Plx>
      <Plx className="right-section" parallaxData={plxData.text} disabled={isMobile}>
        <SectionName>Features</SectionName>
        <BaseTitle>Follow your trusted fund managers and never miss their ideas</BaseTitle>
        <BaseDesc>
          If you’re pressed for time but value the ideas of contributors you trust, Following is a
          great way to stay up to date with the market. We&apos;ll send you an email when
          contributors in your Followed community publish a wire, you can even choose how frequently
          you receive these emails.
        </BaseDesc>
      </Plx>
    </Container>
  );
}
